import { CoreForumNodeCreator } from './CoreForumNodeCreator';
import { useMemo } from 'react';

// 默認標籤配置，用於向後兼容性
const DEFAULT_TAG_CONFIG = {
  idea: { label: '想法', emoji: '💡', color: '#F3E8FF' },
  reply: { label: '回覆', emoji: '💬', color: '#E0F2FE' }
};

/**
 * CoreForumCreateReply - 核心回覆組件
 * @param {string} props.activityId - 活動 ID（可選）
 * @param {string} props.groupId - 群組 ID（可選，向後兼容）
 * @param {string} props.nodeId - 節點 ID（可選）
 */
export const CoreForumCreateReply = ({ 
  open, 
  onClose, 
  nodeContent, 
  ws, 
  graphNodes, 
  graphEdges, // 新增：接收 edges
  allTagConfigs = DEFAULT_TAG_CONFIG,
  groupId, // 向後兼容 ForumChatRoom.js
  activityId, // ✅ 新增參數
  nodeId, // ✅ 新增參數
  ...otherProps // 接收其他可能的 props
}) => {
  // 從被回覆的節點中獲取標籤，如果沒有則使用 'idea'
  const inheritedTag = useMemo(() => {
    return nodeContent?.tags || 'idea';
  }, [nodeContent]);

  // 檢查是否要顯示標籤
  const shouldShowTags = useMemo(() => {
    return Object.keys(allTagConfigs).length > 0;
  }, [allTagConfigs]);

  // 確保有有效的標籤配置
  const validTagConfigs = useMemo(() => {
    if (Object.keys(allTagConfigs).length > 0) {
      return allTagConfigs;
    }
    return DEFAULT_TAG_CONFIG;
  }, [allTagConfigs]);

  return (
    <CoreForumNodeCreator
      open={open}
      onClose={onClose}
      ws={ws}
      graphNodes={graphNodes}
      graphEdges={graphEdges} // 传递 edges
      allTagConfigs={shouldShowTags ? validTagConfigs : {}}
      defaultTag={inheritedTag}
      parentNodeId={nodeContent?.id}
      parentNodeContent={nodeContent} // 傳遞節點內容用於顯示
      dialogTitle="回覆想法"
      isReply={true}
      showTags={shouldShowTags} // 新增：控制是否顯示標籤
      activityId={activityId} // ✅ 傳遞參數
      groupId={groupId} // ✅ 傳遞參數
      nodeId={nodeId} // ✅ 傳遞參數
      {...otherProps} // 傳遞其他可能的 props
    />
  );
}

